import PreactImage from '@/components/snippets/image/image'
import { useEffect, useMemo, useState } from 'preact/hooks'
import Icon from '@/components/snippets/icon/icon'
import { OnBoardingHeader } from './OnboardingHeader'
import { OnBoardingSteps } from './OnboardingSteps'
import { useMobileFiltersContext, LoyaltyOnBoardingContext } from './OnboardingContext'

const NavigationButton = ({ icon, text, callback }) => {
  return (
    <div className={'flex cursor-pointer flex-row gap-2'} onClick={callback}>
      <Icon id={icon} />
      <div className={'paragraph-md underline underline-offset-2'}>{text}</div>
    </div>
  )
}

const NavigationBar = ({ logo, handleView }) => {
  const context = useMobileFiltersContext()

  const callbacks = useMemo(() => {
    return {
      backButton: () => {
        const previousState = context.config.currentState - 1
        const index = previousState < 0 ? 0 : previousState
        context.handleNextStep(index)
      },
      exitButton: handleView,
      helpButton: () => {
        window.location.href = '/pages/help'
      }
    }
  }, [context.config])

  return (
    <div className={'absolute inset-0 z-10 h-11 w-full md:h-16'}>
      <div className={'m-4 flex h-full flex-row items-center justify-between rounded-lg bg-primary-white md:m-6'}>
        <div className={'flex flex-row gap-4 pl-6'}>
          <NavigationButton text={'Back'} icon={'chevron-left'} callback={callbacks.backButton} />
          <span className={'hidden md:block'}>
            <NavigationButton text={'Exit'} icon={'exit'} callback={callbacks.exitButton} />
          </span>
        </div>
        <div>
          <img className="relative w-32 h-6 xl:h-8 xl:w-44" src={logo} />
        </div>
        <div className={'flex flex-row gap-4 pr-6'}>
          <span className={'hidden md:block'}>
            <NavigationButton text={'Need help?'} icon={'chat-operator'} callback={callbacks.helpButton} />
          </span>
          <span className={'md:hidden'}>
            <NavigationButton text={'Exit'} icon={'exit'} callback={callbacks.exitButton} />
          </span>
        </div>
      </div>
    </div>
  )
}

export const OnBoardingModal = (props) => {
  const [view, setView] = useState(props?.isOpen || false)
  const handleView = () => {
    setView((v) => !v)
    if (props.handleOutsideOpen) {
      props.handleOutsideOpen()
    }
  }

  useEffect(() => {}, [props.isOpen])

  if (!view) {
    return (
      <div onClick={handleView} className={'btn btn-lg btn-solid-black fixed z-max'}>
        Open
      </div>
    )
  }

  return (
    <div className={'fixed inset-0 z-max h-screen bg-white'}>
      <div className={'flex h-full justify-between md:flex-row'}>
        <div className={'h-full w-full bg-primary-grey pb-4 lg:w-1/2'}>
          <LoyaltyOnBoardingContext>
            <NavigationBar logo={props.logo} handleView={handleView} />
            <div className={'flex h-full w-full flex-col overflow-y-auto'}>
              <div className={'pt-[6.25rem] md:pt-[7rem]'}>
                <OnBoardingHeader />
              </div>
              <div className={'h-full w-full px-6 pb-10 md:h-auto md:overflow-y-auto md:px-20 md:pb-20'}>
                <OnBoardingSteps handleView={handleView} />
              </div>
            </div>
          </LoyaltyOnBoardingContext>
        </div>
        <div className={'hidden lg:block lg:w-1/2'}>
          <PreactImage
            imageClass="fit object-bottom"
            className={'aspect-4/5 h-full w-full object-cover'}
            key={'id'}
            imageUrl={[accountGlobal?.onboarding?.main_image]}
          />
        </div>
      </div>
    </div>
  )
}
